import { FilterFilled, SearchOutlined } from '@ant-design/icons';
import { Button } from 'antd';
// eslint-disable-next-line no-use-before-define
import * as React from 'react';

import styles from './controls.module.css';

export type SearchTriggerProps = {
  className?: string;
  filterCount: number;
  isActive: boolean;
  onClick: () => void;
  query: string;
};

export type SearchResultsSummaryProps = {
  className?: string;
  resultCount: number;
  totalCount: number;
  onClear: () => void;
};

export const SearchTrigger: React.FC<SearchTriggerProps> = ({
  className,
  filterCount,
  isActive,
  onClick,
  query
}) => {
  const label = query || 'Search';
  let ariaLabel = 'Search';

  if (query) ariaLabel = `Search: ${query}`;
  else if (isActive) ariaLabel = 'Search, active search';

  if (filterCount) {
    const searchLabel = query ? `Search: ${query}` : 'Search';
    ariaLabel = `${searchLabel}, ${filterCount} active filter${
      filterCount === 1 ? '' : 's'
    }`;
  }

  return (
    <button
      aria-label={ariaLabel}
      className={[
        styles.trigger,
        isActive ? styles.triggerActive : '',
        className
      ]
        .filter(Boolean)
        .join(' ')}
      type="button"
      onClick={onClick}
    >
      <SearchOutlined />
      <span className={styles.triggerLabel} title={query || undefined}>
        {label}
      </span>
      {filterCount > 0 && (
        <span aria-hidden="true" className={styles.filterCount}>
          <FilterFilled />
          {filterCount}
        </span>
      )}
    </button>
  );
};

export const SearchResultsSummary: React.FC<SearchResultsSummaryProps> = ({
  className,
  resultCount,
  totalCount,
  onClear
}) => (
  <div
    className={[styles.searchResultsSummary, className]
      .filter(Boolean)
      .join(' ')}
  >
    <span aria-live="polite" className={styles.searchResultsSummaryText}>
      Showing {resultCount} of {totalCount} tasks
    </span>
    <Button
      aria-label="Clear search and filters"
      className={styles.searchResultsSummaryClear}
      onClick={onClear}
      type="link"
    >
      Clear
    </Button>
  </div>
);
